
import React, { useEffect, useState } from "react";
import Papa from "papaparse";

const AuditLogViewer = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [filters, setFilters] = useState({ action: "", module: "", performed_by: "" });

  useEffect(() => {
    fetch("https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/api/audit_log/")
      .then((res) => res.json())
      .then((data) => {
        setLogs(data);
        setFilteredLogs(data);
      });
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);

    const filtered = logs.filter(
      (log) =>
        (!newFilters.action || log.action.includes(newFilters.action)) &&
        (!newFilters.module || log.module.includes(newFilters.module)) &&
        (!newFilters.performed_by || log.performed_by.includes(newFilters.performed_by))
    );
    setFilteredLogs(filtered);
  };

  const exportCSV = () => {
    const csv = Papa.unparse(filteredLogs);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "audit_logs.csv";
    a.click();
  };

  return (
    <div className="container mt-4">
      <h3>🔍 Audit Logs</h3>

      <div className="row mb-3">
        <div className="col-md-3">
          <input className="form-control" placeholder="Filter by Action" name="action" value={filters.action} onChange={handleFilterChange} />
        </div>
        <div className="col-md-3">
          <input className="form-control" placeholder="Filter by Module" name="module" value={filters.module} onChange={handleFilterChange} />
        </div>
        <div className="col-md-3">
          <input className="form-control" placeholder="Filter by User" name="performed_by" value={filters.performed_by} onChange={handleFilterChange} />
        </div>
        <div className="col-md-3 text-end">
          <button className="btn btn-success" onClick={exportCSV}>Export CSV</button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>ID</th>
              <th>Action</th>
              <th>Module</th>
              <th>Details</th>
              <th>Performed By</th>
              <th>Timestamp</th>
            </tr>
          </thead>
          <tbody>
            {filteredLogs.map((log) => (
              <tr key={log.id}>
                <td>{log.id}</td>
                <td>{log.action}</td>
                <td>{log.module}</td>
                <td>{log.details}</td>
                <td>{log.performed_by}</td>
                <td>{new Date(log.timestamp).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditLogViewer;
